module.exports = __webpack_public_path__ + "static/media/microphone@2x.1f1f1cde.png";